import { IconTriangleWarningOutline18 as AlertTriangle } from "nucleo-ui-outline-18"

import { Button, Tooltip } from "@productlane/ui"

import { toast } from "@/components/toast"
import { api } from "@/lib/api"

const TOOLTIP =
	"A reply to this contact bounced. Their address is suppressed on our email provider (hard bounce, spam complaint, or manual suppression). Click to re-subscribe."

export function ContactSuppressionWarning({
	contactId,
	variant = "row",
}: {
	contactId: string
	variant?: "row" | "badge"
}) {
	const reactivate = api.mail.reactivateContactEmail.useMutation({
		onSuccess: (result) => {
			if (result.reactivated) {
				toast.success({ title: "Email reactivated" })
				return
			}
			if (result.reason === "spam_complaint") {
				toast.error({
					title: "Cannot reactivate automatically",
					description:
						"This address was suppressed by a spam complaint. The recipient must confirm they want emails again, then contact Postmark support to reactivate it.",
				})
				return
			}
			toast.error({ title: "Could not reactivate this email" })
		},
		onError: () => {
			toast.error({ title: "Could not reactivate this email" })
		},
	})

	if (variant === "badge") {
		return (
			<Tooltip label={TOOLTIP}>
				<Button
					variant="outline"
					isLoading={reactivate.isLoading}
					className="max-h-6 min-h-6 !text-yellow-600 dark:!text-yellow-400"
					Icon={AlertTriangle}
					onClick={() => reactivate.mutate({ contactId })}
				>
					Email blocked
				</Button>
			</Tooltip>
		)
	}

	return (
		<Tooltip label={TOOLTIP}>
			<Button
				variant="ghost"
				isLoading={reactivate.isLoading}
				className="h-auto justify-start truncate text-xs !text-yellow-600 hover:bg-gray-150 dark:!text-yellow-400 dark:hover:bg-gray-800"
				onClick={() => reactivate.mutate({ contactId })}
			>
				<div className="flex items-center gap-2 truncate">
					<AlertTriangle className="size-[18px] shrink-0" />
					<span className="truncate">Email delivery blocked</span>
				</div>
			</Button>
		</Tooltip>
	)
}
